import * as types from './index';

export const patientFormSubmitAction = (patient) => {
  return {
    type: types.PATIENT_SUBMIT,
    patient
  }
};

export const allPatientsFetchAction = (payload) => {
  return {
    type: types.ALL_PATIENT_FETCH,
    payload
  }
};

export const patientFetchAction = (patient) => {
  return {
    type: types.PATIENT_FETCH,
    patient
  }
};

export const fetchPatiensByPatientNameAction = (patient) => {
  return {
    type: types.FETCH_BY_PATIENT_NAME,
    patient
  }
};

export const fetchPatienByPhoneAction = (patient) => {
  return {
    type: types.FETCH_BY_PATIENT_PHONE,
    patient
  }
};

export const fetchPatiensByAttenderNameAction = (patient) => {
  return {
    type: types.FETCH_BY_ATTENDER_NAME,
    patient
  }
};
export const patientVerifyAction = (patient) => {
  return {
    type: types.PATIENT_VERIFY,
    patient
  }
};

export const patientMatchDonorsAction = (patient) => {
  return {
    type: types.MATCH_DONORS,
    patient
  }
};

export const patientMatchDonorPhoneAction = (payload) => {
  return {
    type: types.MATCH_DONOR_PHONE,
    payload
  }
};

export const updatePatientAction = (patient) => {
  return {
    type: types.PATIENT_UPDATE,
    patient
  }
};

export const saveMatchingDonorAction = (saveMatchingDonorPayload) => {
  return {
    type: types.SAVE_MATCHING_DONOR,
    saveMatchingDonorPayload
  }
};